<template>
  <!-- 通用的页脚 author: zhangxiaofeng -->
  <div class="blocked-footer">
    <p class="f-cb">
      <a href="https://account.glodon.com/about" target="_blank" >关于我们</a>
      <span class="split-line"></span>
      <a href="https://account.glodon.com/contact" target="_blank" >联系我们</a>
      <span class="split-line"></span>
      <router-link to="/agreement" target="_blank" >用户协议</router-link>
      <span class="split-line"></span>
      <router-link to="/privacy" target="_blank" >隐私协议</router-link>
      <span class="split-line"></span>
      <a target="_blank" href="http://jubao.glodon.com/?code=321">举报投诉</a>
    </p>
    <p class="record" ><span>
      <!--Copyright © 1998-{{nowYear}} 广联达科技股份有限公司. 京ICP证010052号 京ICP备10021606号-1 京公网安备110108401054号-->
            Copyright © 1998-{{nowYear}} 广联达科技股份有限公司&nbsp;<a target="_blank" href="https://beian.miit.gov.cn">京ICP备10021606号-1</a>&nbsp;<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802021391">京公网安备11010802021391号</a>
    </span></p>
  </div>
</template>
<style lang="less" type="text/less">
  .blocked-footer{
    padding-top: 12px;
    height: 60px;
    line-height: 22px;
    width: 100%;
    &>p{
      &>*{
        margin-right: 8px;
        font-size:12px;
        color:rgba(32,121,250,1);
      }
      a{
        &:link{
          color:rgba(32,121,250,1);
        }
        &:hover{
          color: #2079FA;
        }
      }
      .split-line{
        display: inline-block;
        width: 1px;
        height: 10px;
        margin-top: 6px;
        background-color: rgba(32,121,250,1);
      }
    }
    .record{
      bottom: 24px;
      span{
        color:rgba(33,37,48,0.55);
        font-size:12px;
      }
      a {
        color:rgba(33,37,48,0.55) !important;
        &:hover {
          color: #2079fa !important;
        }
      }
    }
  }
</style>
<script>
export default {
  name: 'FooterGeneral'
}
</script>
